<app-view-title [showBack]="false"  mode="primary"></app-view-title>

<div  style="display: flex; flex-direction: column; height: 100%;">
  <div style="text-align:center;">
    <img class="logo" src="/Styles/OneWay/Logo.png" style="max-width:250px; margin:40px" />
    <br />
    <p style="margin-bottom:75px">{{'Intellitrailer.SelectFamily.txtWelcomeMessage.' + appSettings.settings.theme | translate: 'Welcome to ' + appSettings.settings.theme + '!'}}</p>
  </div>
 
  <div  style="flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 10; background-size: cover; background-position: center; border-radius: 25px 25px 0px 0px; background-image: url(/Styles/OneWay/Images/bg/Hero-oneway-app.png) ">
    <button [ngStyle]="appSettings?.appType !== 'app' ? {'margin': '10%'} : {}" type="button" mat-raised-button (click)="start()" style="background: white !important; width: 250px; margin-bottom: 30px; color: var(--action-secondary-background) !important; ">{{'Intellitrailer.OneWayStart.BtnRentTrailer' | translate: 'Rent a trailer'}}</button>
    @if(appSettings.appType == 'app'){ <button type="button" mat-raised-button (click)="mybooking()" style="background: white !important; width: 250px; color: var(--action-secondary-background) !important;">{{'Intellitrailer.OneWayStart.BtnMyReservations' | translate: 'My reservations'}}</button>}
  </div>

</div>
<div class="bottom-nav" style="z-index: 15;">
  <div class="bottom-nav-home" *ngIf="typeSettings.isShowMenu">
    <div (click)="toggleNewUserInfo(false)" class="link">{{'Intellitrailer_Home_Home_HowDoesItWork' | translate: 'How does it work?' }}</div>
  </div>
  <!--<div class="bottom-nav-select-location" *ngIf="!typeSettings.isShowMenu">
    <div class="select-location">{{'Intellitrailer_Home_Home_cmdChooseALocation' | translate: 'Choose a location'}}</div>
  </div>-->
</div>

